<template>
  <div class="al-list-group-item" test-id="al-list-group-item">
    <div v-if="!!$slots.left" class="left">
      <slot name="left" />
    </div>
    <slot />
    <div v-if="!!$slots.right" class="right">
      <slot name="right" />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.al-list-group-item {
  align-items: inherit;
  background: color(white, lighten, 1);
  display: flex;

  .left {
    align-items: center;
    display: flex;
    flex-grow: 2;
    font-size: 16px;

    > * {
      margin-right: 10px;
    }
  }

  .right {
    align-items: center;
    display: flex;
    margin-left: auto;

    .text-small {
      color: color(black, lighten, 3);
      font-size: 12px;
    }
  }

  .hover {
    align-items: center;
    display: flex;
    opacity: 0;
  }

  .no-hover {
    opacity: 1;
    width: auto;
  }

  &.new {
    background-color: white;
    border: 1.5px;
    border-color: color(white, darken, 3);
    border-radius: 1px;
    border-style: dashed;
    color: color(black, lighten, 3);
    margin: 25px 0;
    min-height: 77px;
    padding: 18px 28px;

    .placeholder {
      color: color(black, lighten, 3);
    }

    .title {
      color: color(black);
    }

    &:hover {
      background-color: color(white);
    }

    &.no-border {
      border: 0;
      border-style: none;
    }
  }
}

.al-list-group-item:hover {
  .hover {
    opacity: 1;
  }

  .no-hover {
    opacity: 0;
    width: 0;
  }
}

.handle {
  color: color(black, lighten, 3);

  cursor: move;
  cursor: grab;
  margin-right: 15px;
  min-height: 41px;
  transition: opacity 0.6s, margin 0.3s ease-out;

  &.sm {
    min-height: 36px;
  }
}
</style>
